export default () => {
    // keep track of previous scroll position
let prevScrollpos = window.scrollY;
window.onscroll = function() {
    let currentScrollPos = window.scrollY;
    if (currentScrollPos > window.innerHeight/1.5) {
        if (prevScrollpos > currentScrollPos) {
            // document.getElementById("navbar").classList.remove("navHide");
            subMenuToggle('open')
        } else {
            // document.getElementById("navbar").classList.add("navHide");
            subMenuToggle('close')
        }
    } else {
        // document.getElementById("navbar").classList.remove("navHide");
    }
    prevScrollpos = currentScrollPos;
}

function subMenuToggle(goTo) {
    let subMenus = document.getElementsByClassName('projSubs');
    let sm;
    for (sm=0; sm < subMenus.length; sm++) {
        let subMenu = subMenus[sm];
        if (goTo == 'open') {
            
            subMenu.classList.remove('navHide');
            setTimeout(() => {
                subMenu.querySelector('.subInner').classList.remove('opacity-0');
                subMenu.querySelector('.subInner').classList.remove('pointer-events-none');
            }, 500)
            
        } else {
            subMenu.querySelector('.subInner').classList.add('opacity-0');
            subMenu.querySelector('.subInner').classList.add('pointer-events-none');
            setTimeout(() => {
                subMenu.classList.add('navHide');
            }, 100)
            
        }
    }
}
}